import React, { FC, ChangeEvent, FormEvent, MouseEvent } from "react";

import { ParentWithChildDropdownField } from "~/components/organisms";

import { BusinessDivisionType, ParentType, ChildType } from "~/domains";

import { Button, Form, FormSubmitButton } from "~/ui";
import { LabelWithTextArea } from "~/ui";

type PropsType = {
  divisionSection: {
    selectableDivisions: BusinessDivisionType[];
    selectedDivision?: BusinessDivisionType | null;
    onDivisionChange: (newValue: ParentType | null) => void;
    optionSelectableSections: ChildType[];
    optionSelectedSection?: ChildType | null;
    onSectionChange: (newValue: ChildType | null) => void;
  };
  context: {
    value: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  };
  isSubmitting: boolean;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  handleReadonly: (e: MouseEvent<HTMLButtonElement>) => void;
  handleNotReadonly: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  isReadOnly?: boolean;
};

export const AiBusinessSectionContextForm: FC<PropsType> = ({
  divisionSection,
  context,
  isSubmitting,
  className,
  isReadOnly,
  handleSubmit,
  handleReadonly,
  handleNotReadonly,
}: PropsType) => {
  const {
    selectableDivisions,
    selectedDivision,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSection,
    onSectionChange,
  } = divisionSection;

  return (
    <Form className={`space-y-6 ${className}`} onSubmit={handleSubmit}>
      <ParentWithChildDropdownField
        allParents={selectableDivisions}
        parentValue={selectedDivision}
        parentsOnChange={onDivisionChange}
        parentRequired
        parentLabel="部署"
        allChildren={optionSelectableSections}
        childValue={optionSelectedSection}
        childrenOnChange={onSectionChange}
        childRequired
        childLabel="課"
      />
      <LabelWithTextArea
        labelText="最新のAIカスタマイズ"
        name="context"
        placeholder="最新のAIカスタマイズ"
        rows={6}
        value={context.value}
        onChange={context.onChange}
        disabled={isReadOnly || isSubmitting}
      />
      <div className={`flex items-center space-x-4 w-full ${className}`}>
        {isReadOnly ? (
          <Button
            text="新しく投稿する"
            onClick={handleNotReadonly}
            color="gray"
            outline
            className="w-full"
          />
        ) : (
          <>
            <Button
              text="キャンセル"
              onClick={handleReadonly}
              color="gray"
              outline
              className="w-full"
            />
            <FormSubmitButton
              color="primary"
              value="投稿する"
              isReadOnly={isSubmitting}
              className="w-full"
            />
          </>
        )}
      </div>
    </Form>
  );
};
